export default class WrapModalCatalog {
    constructor(catalog, mobileMenu) {
        this.catalog = catalog;
        this.mobileMenu = mobileMenu;

        this.sections = catalog.querySelector('.header-desktop__catalog-left');
        this.headerDesktopContainer = document.querySelector('.header-desktop__container');

        this.wrapperClass = 'header-desktop__catalog-modal';
        this.containerClass = 'header-desktop__catalog-modal-container';

        this.eventRegister();
        this.handleResize(false);
    }

    eventRegister() {
        window.addEventListener('resize', () => this.handleResize(true));
    }

    createWrapper() {
        if (!this.sections) return;
        if (window.innerWidth < 992) return;

        if (this.sections.closest(`.${this.wrapperClass}`)) return;
        if (!this.headerDesktopContainer.classList.contains('main__container')) {
            this.headerDesktopContainer.classList.add('main__container');
        }
        const wrapper = document.createElement('div');
        wrapper.classList.add(this.wrapperClass);

        const container = document.createElement('div');
        container.classList.add(this.containerClass);

        const parent = this.sections.parentNode;

        parent.insertBefore(wrapper, this.sections);

        wrapper.appendChild(container);
        container.appendChild(this.sections);
    }

    removeWrapper() {
        if (!this.sections) return;
        if (this.headerDesktopContainer.classList.contains('main__container')) {
            this.headerDesktopContainer.classList.remove('main__container');
        }
        const wrapper = this.sections.closest(`.${this.wrapperClass}`);
        const container = this.sections.closest(`.${this.containerClass}`);

        if (!wrapper || !container) return;

        const parent = wrapper.parentNode;

        parent.insertBefore(this.sections, wrapper);

        wrapper.remove();
    }

    handleResize(shouldCloseMenu = false) {
        if (!this.sections) return;

        if (shouldCloseMenu) {
            this.mobileMenu?.closeMenu?.();
        }

        const isWrapped = !!this.sections.closest(`.${this.wrapperClass}`);

        if (window.innerWidth >= 992 && !isWrapped) {
            this.createWrapper();
            return;
        }

        if (window.innerWidth < 992 && isWrapped) {
            this.removeWrapper();
        }
    }
}
